import React from 'react';
import { FaGithub,  FaLinkedinIn,  FaDev } from 'react-icons/fa';
import { SiKaggle } from "react-icons/si";
import { FaInstagramSquare } from "react-icons/fa";
import { FaTelegram } from "react-icons/fa";

const HeaderSocials = () => {
    return (
        <div className='home__socials'>
            <a href='https://github.com/ayushsingh991399' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaGithub />
            </a>

            

           

            <a href='https://www.linkedin.com/in/ayush-singh-625a33333/' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaLinkedinIn />
            </a>

            <a href='https://www.instagram.com/ayush_gurjar_10?igsh=MW80cml0N296bGxuZQ==' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaInstagramSquare />
            </a>
            <a href='https://www.kaggle.com/ayushsinghgurjar' className='home__social-link' target='_blank' rel='noreferrer'>
                <SiKaggle/>
            </a>
            <a href='http://t.me/Asingh_2003' className='home__social-link' target='_blank' rel='noreferrer'>
            <FaTelegram/>

            </a>

            
        </div>
    );
};

export default HeaderSocials;
